const BUSINESS_TYPES = [
  {
    label: "Jordbrukshandler / Gårdsbutikk",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Dyrehjem / Veldedighet",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Oppfôringsanlegg",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Storfekjøttprodusent",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Slaktekyllinger", value: "Broilers", id: "broilers" },
  {
    label: "Innkjøpsgruppe",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Kalveproduksjon",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Kalvegård/Utvikler",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Storfekjøper", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Kontraktsdyrker",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Kooperativ", value: "Cooperative", id: "cooperative" },
  {
    label: "Hovedkontor",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Ku/Kalv-drift",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Melkeproduksjon",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributør / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Fôrmølle", value: "Feed Mill", id: "feed_mill" },
  { label: "Fôrgård", value: "Feedyard", id: "feedyard" },
  {
    label: "Dyrker/Dyrkergård",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Klekkeri", value: "Hatchery", id: "hatchery" },
  {
    label: "Kvigeproduksjon",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Verpehønsintegrasjon",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Verpehøns", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Melkekooperativ/Kjøper",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Blandet/Annen produsent",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Næringsstoffleverandør",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Pakker/Prosessor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Dyrebutikk",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apotek", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Fjærfeoppdrett",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Fjærfeintegratør",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Saueprodusent", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Ungdyrdrift",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Dyregård/Salgsfjøs",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Svineprodusent", value: "Swine Producer", id: "swine_producer" },
  { label: "Kalkoner", value: "Turkeys", id: "turkeys" },
  {
    label: "Universitet / Utdanning",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinærpraksis",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Grossist / Detaljhandel",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Ullkjøper", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obligatorisk",
    },
  },
  salutation: {
    label: "Tittel",
    placeholder: "Velg tittel",
    errors: {
      required: "Tittel er obligatorisk",
      invalid: "Velg en gyldig tittel",
    },
  },
  firstName: {
    label: "Fornavn",
    placeholder: "John",
    errors: {
      required: "Fornavn er obligatorisk",
      minLength: "Fornavn må være minst 2 tegn",
      maxLength: "Fornavn kan være maksimalt 50 tegn",
    },
  },
  lastName: {
    label: "Etternavn",
    placeholder: "Doe",
    errors: {
      required: "Etternavn er obligatorisk",
      minLength: "Etternavn må være minst 2 tegn",
      maxLength: "Etternavn kan være maksimalt 50 tegn",
    },
  },
  email: {
    label: "E-post",
    placeholder: "john.smith@example.org",
    description:
      "Vennligst oppgi en e-postadresse som er personlig for deg, ikke en delt e-postadresse.",
    prefixWarningTitle: "Delt postkasse oppdaget",
    prefixWarningDescription:
      "Vi anbefaler å bruke en personlig e-postadresse for en bedre personlig opplevelse",
    errors: {
      required: "E-post er obligatorisk",
      invalidEmail: "Vennligst oppgi en gyldig e-postadresse",
      emailAssociatedWithYourAccount:
        "Din e-postadresse er knyttet til kontoen din og kan ikke endres.",
    },
  },
  confirmEmail: {
    label: "Bekreft e-post",
    placeholder: "john.smith@example.org",
    errors: {
      required: "Bekreft e-post er obligatorisk",
      invalidEmail: "Vennligst oppgi en gyldig e-postadresse",
      emailMatchError: "E-postadressene stemmer ikke overens",
    },
  },
  password: {
    label: "Passord",
    placeholder: "Skriv inn passordet ditt",
    errors: {
      required: "Passord er obligatorisk",
    },
  },
  confirmPassword: {
    label: "Bekreft passord",
    placeholder: "Bekreft passordet ditt",
    errors: {
      required: "Bekreft passord er obligatorisk",
      passwordMatchError: "Passordene stemmer ikke overens",
    },
  },
  addressLine1: {
    label: "Adresselinje 1",
    placeholder: "123 Main St",
    errors: {
      required: "Adresselinje 1 er obligatorisk",
      minLength: "Adresselinje 1 må være minst 5 tegn",
      maxLength: "Adresselinje 1 kan være maksimalt 100 tegn",
    },
  },
  addressLine2: {
    label: "Adresselinje 2",
    placeholder: "Leil 4B",
    errors: {
      required: "Adresselinje 2 er obligatorisk",
      maxLength: "Adresselinje 2 kan være maksimalt 100 tegn",
    },
  },
  city: {
    label: "By / Sted",
    placeholder: "Oslo",
    errors: {
      required: "By / Sted er obligatorisk",
      minLength: "By / Sted må være minst 2 tegn",
      maxLength: "By / Sted kan være maksimalt 50 tegn",
    },
  },
  country: {
    label: "Land",
    placeholder: "Velg land",
    errors: {
      required: "Land er påkrevd",
      invalid: "Vennligst velg et gyldig land",
    },
  },
  state: {
    label: "Fylke",
    placeholder: "Velg fylke",
    errors: {
      required: "Fylke er obligatorisk",
      invalid: "Velg et gyldig fylke",
    },
  },
  jurisdiction: {
    label: "Lisensens jurisdiksjon",
    placeholder: "Velg lisensens jurisdiksjon",
    errors: {
      required: "Lisensens jurisdiksjon er obligatorisk",
      invalid: "Velg en gyldig jurisdiksjon",
    },
  },
  zipCode: {
    label: "Postnummer",
    placeholder: "12345",
    errors: {
      required: "Postnummer er obligatorisk",
      invalid: "Vennligst oppgi et gyldig postnummer",
    },
  },
  role: {
    label: "Rolle",
    placeholder: "Velg din rolle",
    errors: {
      required: "Vennligst velg din rolle",
      invalid: "Velg en gyldig rolle",
    },
  },
  businessType: {
    label: "Bedriftstype",
    placeholder: "Velg bedriftstype",
    errors: {
      required: "Bedriftstype er obligatorisk",
      invalid: "Velg en gyldig bedriftstype",
    },
  },
  businessName: {
    label: "Bedriftsnavn",
    placeholder: "Skriv inn bedriftsnavn",
    errors: {
      required: "Bedriftsnavn er obligatorisk",
      minLength: "Bedriftsnavn må være minst 2 tegn",
      maxLength: "Bedriftsnavn kan være maksimalt 100 tegn",
    },
  },
  businessSearch: {
    label: "Bedriftssøk:",
    addNewAccount: "Legg til ny bedriftskonto",
    canNotFindBusiness: "Finner du ikke bedriften din?",
    guideline:
      "Vennligst oppgi postnummeret ditt, og velg fra listen nedenfor.",
    guidelineForNameSearch:
      "Vennligst oppgi fullt bedriftsnavn, og velg fra listen.",
    placeholder: "Hvor jobber du?",
    noResults: "Ingen resultater funnet",
    searching: "Søker...",
    selectedBusinessHeading: "Valgt bedrift:",
    selectedBusinessNotCorrect: "Ikke riktig?",
    selectedBusinessTryAgain: "Prøv igjen",
    selectedBusinessDismiss: "Avvis bedrift",
    resultsFound: {
      singular: "1 bedrift funnet",
      plural: "Flere bedrifter funnet",
    },
    errors: {
      network:
        "Vi har problemer med å koble til bedriftssøkeren. Prøv igjen senere.",
    },
  },
  explicitConsent: {
    label:
      "Ved å krysse av denne boksen godtar jeg Elancos bruksvilkår og bekrefter at Elanco vil samle inn og behandle min personlige informasjon i samsvar med Elancos personvernerklæring",
    errors: {
      required: "E-postsamtykke er obligatorisk",
    },
  },
  explicitSmsConsent: {
    label:
      "Ved å krysse av i denne boksen samtykker jeg til å motta markedsføringskommunikasjon fra Elanco via SMS/tekstmelding.",
    errors: {
      required: "Samtykke til SMS er påkrevd",
    },
  },
  telephone: {
    label: "Personlig telefon",
    placeholder: "Skriv inn ditt personlige telefonnummer",
    dialCodeLabel: "Kode",
    dialCodePlaceholder: "Søk land…",
    errors: {
      invalid: "Vennligst oppgi et gyldig telefonnummer.",
    },
  },
  businessTelephone: {
    label: "Bedriftstelefon",
    placeholder: "Skriv inn bedriftstelefonnummeret ditt",
    dialCodeLabel: "Kode",
    dialCodePlaceholder: "Søk land…",
    errors: {
      invalid: "Vennligst oppgi et gyldig telefonnummer.",
    },
  },
  professionalNumber: {
    label: "Profesjonsnummer",
    placeholder: "1234567",
    errors: {
      required: "Vennligst oppgi et profesjonsnummer",
      maxLength: "Inntastingen overskrider tegngrensen",
    },
  },
  addressSearch: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  businessSearchField: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  checkbox: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  combobox: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  datePicker: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  dateRange: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  dateTime: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  emailField: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  fileInput: {
    errors: {
      required: "Vennligst velg en fil",
    },
  },
  number: {
    errors: {
      required: "Vennligst oppgi et tall",
      minValue: "Vennligst oppgi en verdi høyere enn minimum",
      maxValue: "Vennligst oppgi en verdi lavere enn maksimum",
    },
  },
  passwordField: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  rangeSlider: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  select: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  telephoneField: {
    errors: {
      required: "Vennligst oppgi kun tall",
      invalidTelephone: "Vennligst oppgi gyldig telefonnummer",
      invalidFormat: "Ugyldig nummerformat",
    },
  },
  text: {
    errors: {
      required:
        "Vennligst bruk kun bokstaver (A-Å), tall (0-9) og ingen symboler",
      maxLength: "Inntastingen overskrider tegngrensen",
      minLength: "Inntastingen må være minst 2 tegn",
    },
  },
  textarea: {
    characters: "tegn",
  },
  time: {
    errors: {
      required: "Dette feltet er obligatorisk",
    },
  },
  form: {
    errors: {
      generic:
        "Vi opplevde en feil ved innsending av skjemaet ditt. Vennligst prøv igjen.",
      reportAnIssue: "Vennligst rapporter et problem.",
      configuration: "Konfigurasjonsfeil",
      noFormQuestionsAvailable: "Ingen skjemaspørsmål tilgjengelig.",
      formComponentLoad:
        "Skjemakomponent kunne ikke lastes på grunn av et felt som ikke støttes.",
      code: "Kode",
      type: "Type",
      missingRequiredFields:
        "Dette skjemaet mangler obligatoriske felt (e-post og/eller samtykke). Vennligst kontakt en administrator for å rette skjemakonfigurasjonen.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Akademiker", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Dyrevelferd - Annet",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Dyrevelferd - Butikkpersonale",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Dyrevelferd - Veterinær",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Dyrevelferd - Veterinærsykepleier",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Dyrevelferd - Frivillig",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Storfekjøtt / Fôrgård utvidelse",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Storfekjøttprodusent",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Oppdretsskip", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Forretningsadministratør / Resepsjonist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Bedriftseier / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Konsulerende ernæringsfysiolog",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Bedriftsveterinæransatt (ikke-sykehus)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Melkeprodusent",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributør", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributørrepresentant, feltbasert",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributørrepresentant, intern",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Utdanningsinstitusjon - Videregående elev",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Utdanningsinstitusjon - Fagskole student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Utdanningsinstitusjon - Universitetsstudent",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medisinsk/Klinikkdirektør",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Ernæring / Fôrsalg",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Ernæringsprofesjonell",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Ernæringsfysiolog", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Kontor/Praksisleder",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC-detaljhandel", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apoteker", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apotek - Personale",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Svineprodusent", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Fjærfeprodusent",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Praksiseier, ikke veterinær",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Resepsjonist/Kundeservice",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Forhandlerbutikk - Personale",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Produsent - Blandet/Annet",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Forhandler",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Saueprodusent",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinær",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trener", id: "trainer" },
  { value: "Veterinarian", label: "Veterinær", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinær, praksiseier",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinærassistent",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinærsykepleier",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinærpraksis - Annet",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinærpraksis - Veterinær",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinærpraksis - Veterinærsykepleier",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinærspesialist",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinærstudent",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinærkirurg",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinærtekniker",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Grossist", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Frøken",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Herr",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Fru",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Fru/Frøken",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
